import React, { useEffect, useState } from 'react';
import { useApi } from '@/contexts/AuthContext';

const C = { navy: '#0D1B2A', slate: '#5C6B7A', line: '#E4E9EF' };
const STATUS = {
  built: { label: 'BUILT', color: '#1B7A3D' },
  partial: { label: 'PARTIAL', color: '#8A6D1D' },
  gap: { label: 'GAP', color: '#B0413E' },
};

export default function RegulatoryWatchPage() {
  const api = useApi();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get('/market-intel/regulatory').then(r => setItems(r.data.items || [])).catch(() => {});
  }, [api]);

  return (
    <div className="space-y-4" data-testid="regulatory-watch-page">
      <p className="text-xs" style={{ color: C.slate }}>
        Hard constraints, not advisory guidance. Each item carries its build consequence and the platform's current answer — the honest status, per the audit of 4 Sep 2026.
      </p>
      {items.map(it => {
        const st = STATUS[it.platform_status] || STATUS.partial;
        return (
          <div key={it.item_id} className="rounded-lg border bg-white p-4" style={{ borderColor: C.line }} data-testid={`reg-${it.item_id}`}>
            <div className="flex flex-wrap items-center justify-between gap-2 mb-1">
              <h3 className="text-sm font-bold" style={{ color: C.navy }}>{it.name}</h3>
              <div className="flex items-center gap-2">
                <span className="text-[10px]" style={{ color: C.slate }}>{it.jurisdiction}</span>
                <span className="px-2 py-0.5 rounded text-white text-[10px] font-bold" style={{ background: st.color }} data-testid={`reg-status-${it.item_id}`}>{st.label}</span>
              </div>
            </div>
            <p className="text-[10px] mb-2" style={{ color: C.slate }}>{it.status_dates}</p>
            <div className="grid md:grid-cols-3 gap-3 text-xs">
              <div>
                <p className="text-[9px] uppercase tracking-wider font-semibold mb-1" style={{ color: C.slate }}>Requirement</p>
                <p style={{ color: C.navy }}>{it.requirement}</p>
              </div>
              <div>
                <p className="text-[9px] uppercase tracking-wider font-semibold mb-1" style={{ color: C.slate }}>Build consequence</p>
                <p style={{ color: C.navy }}>{it.build_consequence}</p>
              </div>
              <div className="p-2 rounded" style={{ background: '#F8FAFC' }}>
                <p className="text-[9px] uppercase tracking-wider font-semibold mb-1" style={{ color: st.color }}>Platform's current answer</p>
                <p style={{ color: C.navy }}>{it.platform_answer}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
